const TABLE_DATA_KEYS = Object.freeze({
    // keys relevant for filters
    SEARCH_EXPRESSION: 'search',
    FILTER_CARD_STATE: 'filterCardState',
    FILTERS: 'filters',
    FILTER_ORDER: 'filterOrder',
    NOT_VISIBLE_FILTERS: 'notVisibleFilters',
    PRESET: 'preset',
    // keys relevant for table
    SORT_BY: 'sortBy',
    SORT_BY_DESC: 'sortByDesc',
    HEADERS: 'headers',
    HEADER_ORDER: 'headerOrder',
    NOT_VISIBLE_HEADERS: 'notVisibleHeaders',
    TRUNCATE_DATA: 'truncateData',
    TRUNCATE_OPTIONS: 'truncateOptions',
    SELECTED: 'selected',
    BULK_IDS: 'bulkIds',
    EXCLUDE_IDS_SELECTION_MODE: 'excludeIdsSelectionMode',
    NUMBER_OF_AFFECTED_ENTRIES: 'numberOfAffectedEntries',
});


export default TABLE_DATA_KEYS;
